<template>
  <div class="">
    <div class="
          flex flex-nowrap
          bg-white
          py-0.75rem
          px-0.8rem
          justify-between
          hover:shadow
        ">
      <div class="flex flex-nowrap">
        <div class="relative">
          <img :src="$firstImage(item.images, 'small')" alt="" class="img h-7rem object-cover cursor-pointer w-7rem"
            @click="go(item.id)" :onerror="defaultUrl" />
          <div class="status absolute z-10 inset-0 " v-if="item.status != 10 || !item.stock">
            <span class=" iconfont icon-yixiajia" v-if="item.status == 0"></span>

            <span class="iconfont icon-yishouqing" v-else-if="!item.stock"></span>
          </div>
        </div>

        <div class="text-left pl-4 space-y-2">
          <p class="font-bold text-base">
            <span class="cursor-pointer hover:underline" @click="go(item.id)">{{ item.name }}</span>
          </p>
          <p class="text-0.88rem  mt-1 text-hex-333333  break-words ">
            <span v-for="item in attributeObj" :key="item.index" class="">
              <span v-for="(value, key) in item" :key="key" class="pr-5">{{ $t(key) }}:{{ value }}</span>
            </span>
          </p>
          <p class="text-0.88rem ellipsis mt-1 text-hex-333333">
            {{ $t("预估重量") }}：{{ item.weight }}KG
          </p>
          <p class="mt-2 text-xs flex mb-2 flex-nowrap space-x-6">
            <span class="text-red-600 text-base">{{ $p(item.price) }}</span>
            <span class="text-gray-400 leading-5">{{ $t("已售") }}：{{ item.sales }}</span>
            <span class="text-gray-400 leading-5">{{ $t('库存') }}：{{ item.stock }}</span>

          </p>
        </div>
      </div>
      <div class="h-auto flex-center mr-6">
        <el-button type="primary" size="small" @click="cl(item)">{{
          $t("采购")
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import bus from "@/API/util/bus.js";
import { last } from "ramda";
export default {
  props: { item: Object, flight: Number },

  setup(props, ctx) {
    const flight = ref(Number(props.flight));
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';

    const go = (id) => {
      ctx.root.$router.push({
        name: "ProductDetail",
        params: { id },
        query: { flight: flight.value },
      });
    };
    const attribute_text = ref();
    attribute_text.value = props.item.attribute_text.split("|");
    const attributeObj = ref();
    onMounted(() => {
      attributeObj.value = [
        { 规格: attribute_text.value[0] },
        // { 等级: "A" + ctx.root.$t("级") },
        { 成熟度: last(attribute_text.value) },
        {
          枝长: attribute_text.value[2],
        },
        { 花苞大小: attribute_text.value[3] },
        { 颜色: attribute_text.value[1] },
      ];
    });

    const cl = (e) => {
      bus.emit("select", e);
    };
    return { go, cl, defaultUrl, attributeObj };
  },
};
</script>

<style scoped lang="scss">@import "@/style/stl.scss";
#airlift::before {
  content: "空运：$ ";
}
#tally::after {
  font-size: 0.75rem;
  line-height: 1rem;
  content: " / 扎起";
}
.status {
  background-color: rgba(0, 0, 0, 0.4);
  color: #ffffff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.status .iconfont {
  font-size: 4rem;
}</style>
